"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { FullscreenRoutedPage } from './deskUi/FullscreenRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function FullscreenSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={FullscreenRoutedPage} Loading={MsgDeskLoading} />
}
